import React from 'react';
import { useField } from 'formik';

interface ElogInputProps {
    label: string;
    name: string;
    type?: string;
    mandatory?: boolean;
    classes?: string;
    unit?: string;
    button?: React.ReactNode; // New optional parameter for button component
}

const ElogInput: React.FC<ElogInputProps> = ({ label, name, type = 'text', mandatory = false, classes, unit, button }) => {
    const [field, meta] = useField(name);

    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td>
                <input
                    {...field}
                    value={field.value ?? ''}
                    id={name}
                    type={type}
                    autoComplete="off"
                    className={`text ${classes}`}
                />
                {unit && <span style={{ paddingLeft: '5px' }}>{unit}</span>}
                {button && <span style={{ paddingLeft: '5px' }}>{button}</span>}
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </td>
        </tr>
    );
};

export default ElogInput;
